<template>
  <Loading ref="loading" minHeight="40vh">
      <div v-if="isUserNotFound" class="h5" style="padding:30px;">ユーザーが見つかりませんでした。</div>
      <div v-else>
        <ProfileBackgroundImage :src="backgroundSrc"></ProfileBackgroundImage>
        <div class="container">
          <div style="flex-wrap: wrap;display: flex;align-items: center;">
            <div>
              <img class="avatarImage img-thumbnail" style="border-radius: 50%" alt="avatar" :src="urls.getUserImageSrc(userProfile.user)" />
            </div>
            <router-link v-if="isPageOwner" style="padding:0.375rem 1rem;font-size:0.95rem;margin-left: auto;margin-top: auto;margin-bottom: 0.3rem;" to="/account/">
              編集画面へ
            </router-link>
            <!--/* todo:フォローボタンの表示は通知、タイムラインへの影響など実際に効果のある実装をしてから 
            <button v-else-if="isViewFollowButton"
              type="button"
              autocomplete="off"
              class="btn follow_btn" style="width: 75%; min-width:140px;"
              :class="userProfile.user.isFollowedByLoginUser ? 'btn-outline-primary' : 'btn-primary'"
              
              @click="onFollowButton"
            >
              <span v-if="!userProfile.user.isFollowedByLoginUser"> フォローする </span>
              <span v-else> フォロー済み </span>
            </button>
            */-->
          </div>

          <!--/*  ユーザー名、アカウント名、ユーザー説明 */-->
          <div class="row" style="margin-bottom: 0.25rem">
            <div class="col-12" style="margin-bottom: 0.5rem; padding-top: 1rem; padding-bottom: 0.25rem">
              <div>
                <span class="h4" style="padding:4px 10px;">{{ userProfile.user.displayName }}</span>
              </div>
              <div v-if="userProfile.profile.location">
                <div class="properties_title" style="display: inline-block">
                  <small style="color: #6c757d">地域 : </small>
                </div>
                <span>{{ userProfile.profile.location }}</span>
              </div>
              <div v-if="formatDate(userProfile.profile)">
                <div class="properties_title" style="display: inline-block">
                  <small style="color: #6c757d">誕生日 : </small>
                </div>
                <span>{{ formatDate(userProfile.profile) }}</span>
              </div>
              <div v-if="userProfile.profile.website">
                <div class="properties_title" style="display: inline-block">
                  <small style="color: #6c757d">website : </small>
                </div>
                <a @click="onLinkClick" style="text-decoration: underline;cursor: pointer;" >{{ userProfile.profile.website }}</a>
              </div>
            </div>
            <div v-if="userProfile.profile.selfIntroduction" style="padding:0 15px;">
              <p style="word-break: break-word; word-wrap: break-word">{{ userProfile.profile.selfIntroduction }}</p>
            </div>
          </div>
        </div>

        <div style="width:90vw;margin-left:auto;margin-right:auto;">
          <div class="tabs" style="margin-top: 1rem; margin-bottom: 1rem">
            <ul class="nav nav-tabs nav-fill">
              <!--/* todo:いいね、はLGTMみたいなやつだと思うので、数値のみ表示。誰が押したかわからんけどその数、みたいなやつにするか。
              <li class="nav-item">
                <router-link :to="'/' + userProfile.user.userName + '/good'" class="nav-link" :class="getActiveClass('good')">
                  いいね
                  {{ userProfile.goodCount }}
                </router-link>
              </li>
              */-->
              <li class="nav-item">
                <router-link
                  :to="'/' + userProfile.user.userName + '?tab=comments'" 
                  class="nav-link" 
                  :class="getActiveClass('comments')"
                  :tabindex="getTabIndex('comments')"              
                >
                  コメント
                </router-link>
              </li>
              <li class="nav-item">
                <router-link 
                  :to="'/' + userProfile.user.userName + '?tab=badge'" 
                  class="nav-link" 
                  :class="getActiveClass('badge')"
                  :tabindex="getTabIndex('badge')"
                  >
                  バッジ
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  :to="'/' + userProfile.user.userName + '?tab=public-page'" 
                  class="nav-link" 
                  :class="getActiveClass('public-page')"
                  :tabindex="getTabIndex('public-page')"
                >
                  公開ページ
                </router-link>
              </li>
              <!--/* todo:フォローユーザの動向を記録するものができたら表示。またフォローの分類ができるようにする。英語とか、エンタメとか、フットサルとか、そういうフォルダ分類。
              <li class="nav-item">
                <router-link :to="'/' + userProfile.user.userName + '/profile/following'" class="nav-link" :class="getActiveClass('following')">
                  <span class="h5">{{ userProfile.followCount }} </span>
                  <span class="h6">フォロー</span>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link :to="'/' + userProfile.user.userName + '/profile/followed'" class="nav-link" :class="getActiveClass('followed')">
                  <span class="h5">{{ userProfile.followedCount }} </span>
                  <span class="h6">フォロワー</span>
                </router-link>
              </li>
              */-->
            </ul>

            <div class="tab-content">
              <div class="navColor" style="padding-top: 1rem; padding-bottom: 3rem">
                <LazyShow :show="getActiveClass('comments')">
                  <Comments :user="userProfile.user"/>
                </LazyShow>
                <LazyShow :show="getActiveClass('badge')">
                  <PublicBadge :userName="userName" />
                </LazyShow>
                <LazyShow :show="getActiveClass('public-page')">
                  <PublicProject :list="userProfile.publicPageList" />
                </LazyShow>
              </div>
              <!--/*
              <div class="navColor" style="padding-top: 1rem" v-if="getActiveClass('following')">
                <following />
              </div>
              <div class="navColor" style="padding-top: 1rem" v-if="getActiveClass('followed')">
                <following />
              </div>
              */-->
            </div>
          </div>
        </div>
      </div>
  </Loading>
</template>
<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import {  Watch, Ref } from "vue-property-decorator";
import RootVue from "@/RootVue.vue";
import UserProfileResp from "@/interface/api/UserProfileResp";
import ProfileBackgroundImage from "@/component/profile/ProfileBackgroundImage.vue";
import Comments from "@/pages/user/Comments.vue";
import Loading from "@/component/Loading.vue";
import Following from "@/pages/user/Following.vue";
import PublicProject from "@/pages/user/PublicProject.vue";
import PublicBadge from "@/pages/user/PublicBadge.vue";
import LazyShow from "@/component/parts/LazyShow.vue";

import ProfileResp from '@/interface/api/ProfileResp';
import urls from "@/URLs";


// jsは、new Date("2019-01-01")、new Date("2019/1/1")等でUTCからの時差が変わったりするので、その辺を扱うようになればdayjsを導入する
// import dayjs from "dayjs";
// import "dayjs/locale/ja";
// dayjs.locale("ja");

@Options({
  components: {
    ProfileBackgroundImage,
    PublicProject,
    PublicBadge,
    Comments,
    Loading,
    Following,
    LazyShow,
  },
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;

  //mounted前のlifesycleだと初期化されていないので使用できない点に注意
  @Ref() readonly loading = null as any as Loading;
  readonly urls = urls;
    
  // userがいない場合
  isUserNotFound: boolean = false;

  userProfile: UserProfileResp = {} as any;

  get userName(){
    return this.$route.params.userName as string
  }
  get backgroundSrc(){
    if(this.userProfile){
      return this.urls.getUserBackgroundSrc(this.userProfile.profile);
    }else{
      return null
    }
  }

  getActiveClass(tabName:string){
    //ユーザ画面のURLはQueryString形式にしておく。下記4.を採用。
    //1. /<ユーザ名>/profile/xxxx 形式 -> 長い。profileというプロジェクトが作れなくなる。profile以外にURLが必要になったら大変(手遅れ)
    //2. /<ユーザ名>#xxxx 形式         -> 短いが、#xxxxによって大きく表示コンテンツが変わるので、SEO的に同じページと扱われうる#はあまりよろしくない。#自体、馴染みが低い
    //3. /<ユーザ名>?xxxx 形式         -> 短いが、?xxxx1&xxxx2のように２つのタブを併記できる形式なので見送り
    //4. /<ユーザ名>?tab=xxxx 形式     -> ?tab=という表記が目障り。だけどそれ以外にデメリットがない。
    if(this.$route.query.tab){
      return this.$route.query.tab === tabName ? "active" : '';
    }else{
      //URLでタブ名が指定されてない場合のデフォルトタブ
      return tabName === "comments" ? "active": "";
    }
  }
  getTabIndex(tabName:string){
    return this.getActiveClass(tabName) ? "-1" : "0";
  }

  // プロフィール情報を取得
  getProfileData() {
    this.loading?.start()
    this.isUserNotFound = false
    this.$root.restAccess.getUserData(this.userName).then((res: Response) => {
      if (res.ok) {
        res.json().then((data: UserProfileResp) => {
          this.loading?.finish()
          this.userProfile = data;
        });
      }else{
        this.loading?.finish()
        if(res.status === 404){
          this.isUserNotFound = true;
        }
      }
    });
  }

  // 本人のページかどうか
  get isPageOwner() {
    return this.$root.account.info.userName === this.userName;
  }

  // Followボタンを表示するかどうか
  get isViewFollowButton() {
    // エラーページ表示中
    if (this.isUserNotFound) {
      return false;
    }

    // ログアウト中
    if (!this.$root.account.isLogin) {
      return false;
    }

    // 自分のページではない
    return !this.isPageOwner;
  }

  // ユーザーをフォローする
  followUser() {
    this.$root.restAccess.followUser(this.userName).then((res) => {
      console.log(res);
      // ログインしていない場合確認。
      if (res.status === 403) {
        this.$root.account.reload();
        return;
      }
      // エラー
      if (res.status >= 400) {
        return;
      }
      this.userProfile.user.isFollowedByLoginUser = true;
    });
  }

  // フォローを外す
  unFollowUser() {
    this.$root.restAccess.unFollowUser(this.userName).then((res) => {
      console.log(res);
      if (res.status === 403) {
        this.$root.account.reload();
        return;
      }
      if (res.status >= 400) {
        return;
      }
      this.userProfile.user.isFollowedByLoginUser = false;
    });
  }

  // フォローボタンを押したとき
  onFollowButton(e: any) {
    // フォローしていたら解除、していなかったらフォロー
    if (this.userProfile.user.isFollowedByLoginUser) {
      console.log("unfollow");
      this.unFollowUser();
    } else {
      this.followUser();
    }
    e.currentTarget.blur();
  }

  // 誕生日を日本語表記する
  formatDate(profile:ProfileResp ) {
    if (profile){
      if(profile.birthYear && profile.birthMonth) {
        return `${profile.birthYear}年${profile.birthMonth}月`;
      }
      if(profile.birthYear){
        return `${profile.birthYear}年`;
      }
      if(profile.birthMonth){
        return `${profile.birthMonth}月`;
      }
    }
    return null
  }

  onLinkClick(){
    if(confirm("次のサイトに移動します。フィッシングサイト等にご注意ください。\n" + this.userProfile.profile.website)){
      window.location.href = this.userProfile.profile.website as any
    }
  }

  // 初期情報
  init() {
    document.title = "プロフィール：" + this.userName;
    this.getProfileData();
  }

  // 表示しているユーザ（this.userName）が変わったとき初期化（URLでユーザ部分だけが変わった場合などは画面をリロードしないのでWatchが必要）
  @Watch("userName", { immediate: false, deep: false })
  onUrlChange(newVal: any) {
    if(newVal){
      this.init();
    }
  }

  // 生成時、初期化
  created() {
    this.init();
  }
}
</script>

<style lang="scss" scoped>
/* アバター画像 */
.avatarImage {
  width: 5rem;
  height: 5rem;
}

@media (min-width: 992px) {
  .avatarImage {
    top: -75px;
    left: 10px;
  }
}

@media (min-width: 1200px) {
  .avatarImage {
    left: 17px;
  }
}

/* プロフィール細かい情報 タイトル */
.properties_title {
  width: 63px;
}

.width100 {
  width: 100vh;
}

.height100 {
  height: 100%;
}
</style>